import { render, staticRenderFns } from "./ResultsTableBenefits.vue?vue&type=template&id=02bf3e84&scoped=true&"
import script from "./ResultsTableBenefits.vue?vue&type=script&lang=js&"
export * from "./ResultsTableBenefits.vue?vue&type=script&lang=js&"
import style0 from "./ResultsTableBenefits.vue?vue&type=style&index=0&id=02bf3e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bf3e84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VCol,VRow,VSimpleTable})
